module.exports = __webpack_public_path__ + "img/55.c109ced9.jpg";